/* Rednas Kitchen: WhatsApp-knop rechtsonder.
   De knop werkt ook zonder JavaScript; dit script voegt alleen het
   minimaliseren toe en onthoudt die keuze, zodat de knop op mobiel niet
   bij elke pagina opnieuw in de weg gaat staan. */
(function () {
  var KEY = "rednas-whatsapp-v1";
  var widget = document.querySelector("[data-wa]");
  if (!widget) return;

  var knop = widget.querySelector("[data-wa-knop]");
  var minimaliseer = widget.querySelector("[data-wa-min]");

  function zet(status) {
    widget.dataset.waStatus = status;
    knop.setAttribute("aria-label", status === "klein"
      ? "WhatsApp-knop weer tonen"
      : "Stuur ons een bericht via WhatsApp");
    try { localStorage.setItem(KEY, status); } catch (e) {}
  }

  var bewaard = null;
  try { bewaard = localStorage.getItem(KEY); } catch (e) {}
  zet(bewaard === "klein" ? "klein" : "groot");
  // pas na het zetten van de beginstand animeren, anders schuift de knop
  // bij het laden zichtbaar van groot naar klein
  requestAnimationFrame(function () { widget.classList.add("wa-klaar"); });

  minimaliseer.addEventListener("click", function () { zet("klein"); });

  // in de kleine stand is de knop een tab om weer uit te klappen,
  // niet de link naar WhatsApp zelf
  knop.addEventListener("click", function (e) {
    if (widget.dataset.waStatus === "klein") {
      e.preventDefault();
      zet("groot");
    }
  });

  // De knop zweeft rechtsonder en kwam daardoor over "In winkelmand" te liggen.
  // Zolang een hoofdknop op die plek staat, wijkt WhatsApp; net zoals hij al
  // wijkt voor de cookiebanner en de melding uit de winkelmand.
  var hoofdknoppen = [].slice.call(document.querySelectorAll('form[action$="/cart/add"] [name="add"], .btn-solid'));
  if (hoofdknoppen.length) {
    var wacht = false;

    function overlapt() {
      var w = knop.getBoundingClientRect();
      return hoofdknoppen.some(function (el) {
        var r = el.getBoundingClientRect();
        if (r.width === 0 && r.height === 0) return false;    // verborgen element
        return r.left < w.right && r.right > w.left && r.top < w.bottom && r.bottom > w.top;
      });
    }
    function kijk() {
      wacht = false;
      widget.classList.toggle("wa-wijkt", overlapt());
    }
    function plan() {
      if (wacht) return;
      wacht = true;
      requestAnimationFrame(kijk);
    }

    window.addEventListener("scroll", plan, { passive: true });
    window.addEventListener("resize", plan);
    kijk();
  }
})();
